const getters = {
    language: state => state.common.language
}
export default getters